import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const basicSchema = Yup.object().shape({
    name: Yup.string().required("Name name is required"),
    email: Yup.string().required("Description  is required"),
   // gender: Yup.string().required("Gender  is required"),
    phoneNumber: Yup.string().required("Phone Number  is required"),
    roleId: Yup.string().required("Role  is required"),

    password: Yup.string().required("Password  is required"),
    confPassword: Yup.string().required("confirmation Password  is required"),
    profilePicture: Yup.string().required("Profile Picture  is required"),


    //phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required()
});

const Add = ({ showModal, hideModal }) => {
    const history = useNavigate();
    
    const onSubmit = async (values, actions) => {

        await new Promise((resolve) => setTimeout(resolve, 1000));
        addUser(values);
    };

    const { values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit, submitForm } = useFormik({
            initialValues: {
                name: "",
                email: '',
                phoneNumber: "",
                // gender: '',
                phoneNumber: "",
                roleId: "",
                password: "",
                confPassword: "",
                profilePicture: ""


            },
            validationSchema: basicSchema,
            onSubmit
        })

    const DatePickerField = ({ name, value, onChange }) => {
        return (
            <DatePicker
                selected={(value && new Date(value)) || null}
                onChange={val => {
                    onChange(name, val);
                }}
            />
        );
    };
    const notifySuccess = () => toast.success('Driver Added.', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifyError = () => toast.error('Something went wrong ...', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const addUser = async (e) => {

        try {

            const bodyFormData = new FormData();
            for (let value in values) {
                bodyFormData.append(value, values[value]);
            }
            const responce = await axios.post("/users", bodyFormData);
            history("/users");
            hideModal();
            notifySuccess();
            console.log(responce.status)
        } catch (error) {
            
                notifyError();
          
        }
    };


    return (


        <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">
            <Modal
             style={{marginTop: "60px"}} 
                show={showModal}
                onHide={hideModal}
                backdrop={false}
                contentClassName="custom-modal-style"
            >

                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body
                >

                    <div class="row" >
                        <div class="col-md-6">
                            <div class="card card-primary">

                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="inputName">Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.name && touched.name ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.name && touched.name && <p className="error">{errors.name}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Email</label>
                                        <input
                                            type="text"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.email && touched.email ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.email && touched.email && <p className="error">{errors.email}</p>}

                                    </div>


                                    <div class="form-group">
                                        <label for="inputName">Phone</label>
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            value={values.phoneNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.phoneNumber && touched.phoneNumber ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.phoneNumber && touched.phoneNumber && <p className="error">{errors.phoneNumber}</p>}

                                    </div>
                                    {/* <div className="form-group">
                    <label for="inputStatus">Gender</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.gender && touched.gender ? "form-control input-error" : "form-control "}

                    >
                      <option selected>
                        Select Gender
                      </option>

                      <option value="Male"> Male </option>
                      <option value="Female"> Female </option>
                            
                    </select>
                    {errors.vehicleTypeId && touched.vehicleTypeId && <p className="error">{errors.vehicleTypeId}</p>}

                  </div> */}



                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card card-primary">

                                <div class="card-body">


                                  


                                    <div class="form-group">
                                        <label for="inputName">Address</label>
                                        <input
                                            type="text"
                                            name="address"
                                            value={values.address}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.address && touched.address ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.address && touched.address && <p className="error">{errors.address}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Password</label>
                                        <input
                                            type="text"
                                            name="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.password && touched.password ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.password && touched.password && <p className="error">{errors.password}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Confirm Password</label>
                                        <input
                                            type="text"
                                            name="confPassword"
                                            value={values.confPassword}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.confPassword && touched.confPassword ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.confPassword && touched.confPassword && <p className="error">{errors.confPassword}</p>}

                                    </div>


                                    <div class="form-group">
                                        <label for="inputName">Additional Information</label>
                                        <input
                                            type="text"
                                            name="additionalInformation"
                                            value={values.additionalInformation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.additionalInformation && touched.additionalInformation ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.additionalInformation && touched.additionalInformation && <p className="error">{errors.additionalInformation}</p>}

                                    </div>

                                </div>
                            </div>
                        </div>



                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={hideModal}>
                        Cancel
                    </Button>

                    <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
                        Submit
                    </button>

                </Modal.Footer>

            </Modal>
        </form>

    );
};

export default Add;
